/**
 * Qual credencial vai no cabecalho de uma requisicao.
 *
 * Funcao pura para poder ser testada: o interceptor do axios nao e testavel
 * aqui (o Jest do CRA nao transforma o axios, que e ESM).
 *
 * A REGRA QUE FALTAVA: quem chama manda mais que o token guardado.
 *
 * O interceptor sobrescrevia SEMPRE o Authorization com o access token do
 * storage. Isso quebrava o unico lugar que precisa de outra credencial: a
 * renovacao da sessao, que manda o REFRESH token. Na hora de renovar, o access
 * guardado esta vencido — e por isso que se esta renovando —, entao o servidor
 * respondia 401 e o cliente concluia que o REFRESH e que era invalido, jogando
 * fora uma credencial de 30 dias. Resultado: sessao morrendo em ~12h.
 */

export function autorizacaoDaRequisicao({ jaDefinido, tokenGuardado }) {
  if (jaDefinido) return jaDefinido;
  if (tokenGuardado) return `Bearer ${tokenGuardado}`;
  return null;
}
